import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

// Per-run LLM model picker for the remediate card: one of the backend's curated choices
// (served on the bootstrap payload), initialized by the page to the server's default.
// The selected key rides on the trigger body; an empty selection sends nothing, so the
// server's env-configured model applies.
const ModelSelect = ({ models, value, onChange, disabled }) => (
    <FormControl size='small' sx={{ minWidth: 180 }} disabled={disabled}>
        <InputLabel id='llm-model-label'>Model</InputLabel>
        <Select
            labelId='llm-model-label'
            label='Model'
            value={value || ''}
            onChange={event => onChange(event.target.value)}
        >
            {models.map(model => (
                <MenuItem key={model.key} value={model.key} dense>
                    {model.label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
)

export default ModelSelect
